/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Movement_Breakdown_Select_AllInputs */

const vi_movement_breakdown_select_all = /** @type {(inputs: Movement_Breakdown_Select_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn / bỏ chọn tất cả`)
};

/**

* @param {Movement_Breakdown_Select_AllInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const movement_breakdown_select_all = /** @type {((inputs?: Movement_Breakdown_Select_AllInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Movement_Breakdown_Select_AllInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_movement_breakdown_select_all(inputs)
});